import API from 'API/index'
import {enqueueSnackbar as enqueueSnackbarAction} from 'store/actions/notifier'
import * as typeNotifier from 'shared/typeNotifications'
import * as informationMessages from 'constants/infoMessages'

export const START_LOAD_BUSINESS_PLAN_DETAILS = 'START_LOAD_BUSINESS_PLAN_DETAILS'
export const SUCCESS_LOAD_BUSINESS_PLAN_DETAILS = 'SUCCESS_LOAD_BUSINESS_PLAN_DETAILS'
export const ERROR_LOAD_BUSINESS_PLAN_DETAILS = 'ERROR_LOAD_BUSINESS_PLAN_DETAILS'

export const loadDataBusinessPlanDetails = t => dispatch => {
  dispatch({type: START_LOAD_BUSINESS_PLAN_DETAILS})
  API.getDataBusinessPlan({isDetails: true})
    .then(({data}) => {
      dispatch({
        type: SUCCESS_LOAD_BUSINESS_PLAN_DETAILS,
        data,
      })
    })
    .catch(() => {
      dispatch({
        type: ERROR_LOAD_BUSINESS_PLAN_DETAILS,
      })
      dispatch(
        enqueueSnackbarAction({
          message: t(`infoMessages:${informationMessages.DATA_LOADING_ERROR}`),
          options: {
            variant: typeNotifier.ERROR,
          },
        }),
      )
      console.error('LOAD_ALL_CHARTS')
    })
}
